import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import { URL_API } from "config";
import ic_upload_icon from "../../assets/images/ic_document_icon.png";
import pdf_icon from "../../assets/images/pdf_icon.png";
import png_icon from "../../assets/images/png_icon.png";
import jpg_icon from "../../assets/images/jpg_icon.png";
import jpeg_icon from "../../assets/images/jpeg_icon.png";
import { useNavigate, useParams } from "react-router-dom";
import { DropzoneFilesContainer, DropzoneFiles, ImgFile, InputFile, DivFile, ImgFile2, ButtonDiv, PDFView, LengthInfo } from "./style";
import { Box, Collapse, Icon, IconButton, List, ListItemButton, ListItemText, Modal, Typography } from "@mui/material";
import ImageView from '../ImageView/index';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { toast } from "react-toastify";
import { CrudCooperatedContext } from "context/CrudCooperatedContext";

export default function DropZoneFiles({ onChange, accept, typeFile, NameDescription, required = false }) {
  const [files, setFiles] = useState([]);

  const { uuid } = useParams();

  const { documents, setDocuments } = useContext(CrudCooperatedContext);

  const [dockPreview, setDockPreview] = useState([]);
  const [trigger, setTrigger] = useState(0);
  const [key, setKey] = useState(null);
  const [src, setSrc] = useState();
  const [open, setOpen] = useState(false);
  const [selectOpen, setSelectOpen] = useState(false);

  let tag = localStorage.getItem("Tag");

  const navigate = useNavigate();

  useEffect(() => {
    if (uuid) {
      getDocs();
    } else {
      setDockPreview([]);
    }
    // eslint-disable-next-line
  }, [open === false, uuid])

  useEffect(() => {
    if (src) setOpen(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger])

  useEffect(() => {
    if (onChange) onChange(files);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [files])

  const base64 = (document_uuid) => {
    if (uuid !== "criar") {
      getCooperatedDocument(document_uuid).then((res) => {
        if (res !== 500) {
          setSrc(filename(res.type, res.fileToBase64));
          setDockPreview([res]);
          setTrigger(trigger + 1);
        } else {
          setDockPreview([]);
        }
      });
    }
  }

  const getDocs = async () => {
    try {
      const response = await axios.get(URL_API + `/cooperated/${uuid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      });

      switch (typeFile) {
        case "identification_document":
          response?.data?.documents?.dock?.length && setDockPreview(response?.data?.documents?.dock);
          break;
        case "marital_status":
          response?.data?.documents?.marital?.length && setDockPreview(response?.data?.documents?.marital);
          break;
        case "address_proof":
          response?.data?.documents?.proof?.length && setDockPreview(response?.data?.documents?.proof);
          break;
        case "income_proof":
          response?.data?.documents?.income?.length && setDockPreview(response?.data?.documents?.income);
          break;
        case "subscription_card":
          response?.data?.documents?.signature?.length && setDockPreview(response?.data?.documents?.signature);
          break;
        default:
          break;
      }

      setDocuments(!documents);
    } catch (error) {
      console.error(error);
    }
  }

  // const handleFileChange = (event) => selectFiles(event.target.files);
  const handleFileChange = (e) => {
    switch (NameDescription) {
      case "Adicionar Frente e Verso do Documento de Identificação":
        uploadFile(e.target.files[0], typeFile);
        break;
      case "Adicionar Comprovante Estado Civil":
        uploadFile(e.target.files[0], typeFile);
        break;
      case "Adicionar Comprovante de Residência":
        uploadFile(e.target.files[0], typeFile);
        break;
      case "Adicionar Comprovante de Renda":
        uploadFile(e.target.files[0], typeFile);
        break;
      case "Adicionar Ficha de Interesse":
        uploadFile(e.target.files[0], typeFile);
        break;
      default:
        break;
    }
  };

  const handleClick = () => setSelectOpen(!selectOpen);

  const uploadFile = async (file, type) => {
    try {
      const fl = new FormData();

      fl.append("file", file);

      if (file.size <= 1048576) {
        await axios.post(URL_API + `/file/upload/${uuid}?extension=${file.type}&type=${type}`, fl, {
          headers: {
            Authorization: `Bearer ${tag}`,
            "Content-Type": "multipart/form-data",
          },
        });

        await getDocs();
      } else {
        toast.info('Arquivo maior que 1 MB');
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        localStorage.removeItem("Tag");
        navigate("/auth/login");
      } else {
        toast.error(error?.response?.data?.message);
      }
    }
  }

  const getCooperatedDocument = async (document_uuid) => {
    try {
      const res = await axios.get(URL_API + `/user-documents/${uuid}/document?file=${document_uuid}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("Tag")}`,
        },
      });

      return res.data;
    } catch (error) {
      return 500;
    }
  }

  const remove = (file) => {
    setFiles((files) => {
      const newFiles = files;
      newFiles.splice(newFiles.indexOf(file), 1);
      return [...newFiles];
    });
  }

  const removePreview = async (file) => {
    setDockPreview((files) => {
      const newFilesP = files;
      newFilesP.splice(newFilesP.indexOf(file), 1);
      return [...newFilesP];
    });

    return false;
  }

  const dropped = async (event) => {
    event.preventDefault();

    const newFiles = [];

    if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
      for (const item of event.dataTransfer.items) {
        newFiles.push(item.getAsFile());
      }
    } else if (event.dataTransfer.files.length > 0) {
      for (const item of event.dataTransfer.files) {
        newFiles.push(item);
      }
    }

    // selectFiles(newFiles);
  };

  const dragover = (event) => event.preventDefault();

  const filename = (type, value) => {
    const png = 'data:image/png;base64,';
    const jpg = 'data:image/jpg;base64,';
    const jpeg = 'data:image/jpeg;base64,';
    const pdf = 'data:application/pdf;base64,';

    const fileToBase64 = `${type === 'png' ? png : type === 'jpeg' ? jpeg : type === 'jpg' ? jpg : pdf}${value}`;

    return fileToBase64
  }

  return (
    <DropzoneFilesContainer>
      <DropzoneFiles
        className="dropzoneFiles"
        onDrop={dropped}
        onDragOver={dragover}
      >
        {required && <Typography variant="caption" color='secondary' marginTop={2}>
          Informação obrigatória <strong style={{ color: 'red' }} >*</strong>
        </Typography>}
        <InputFile
          type="file"
          accept={accept}
          onChange={handleFileChange}
        />
        <ImgFile src={ic_upload_icon} />
        {NameDescription}
      </DropzoneFiles>
      <List
        sx={{ bgcolor: '#d2d3db', borderRadius: '0 0 8px 8px', marginBottom: '1rem' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        <ListItemButton onClick={handleClick} disabled={!(dockPreview.length + files.length)}>
          <ListItemText primary={
            <Box display='flex' justifyContent='flex-start'>
              <Typography variant="h6">{NameDescription.split('Adicionar ')[1]}</Typography>

              <LengthInfo disabled>{dockPreview.length + files.length}</LengthInfo>
            </Box>
          } />
          {selectOpen && (dockPreview.length + files.length) ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse
          in={selectOpen && (dockPreview.length + files.length)}
          timeout="auto"
          unmountOnExit
          sx={{
            bgcolor: 'background.paper',
            borderBottom: '2px solid #d2d3db',
            borderLeft: '2px solid #d2d3db',
            borderRight: '2px solid #d2d3db',
            borderRadius: '0 0 8px 8px'
          }}
        >
          <List component="div" disablePadding>
            {!files.length && dockPreview.length ? dockPreview.map((preview) => {
              return (
                <>
                  <ListItemButton sx={{ pl: 4 }}>
                    <DivFile key={preview.key} style={{ flex: 1 }}>
                      {preview.key?.split('.').pop() === "pdf" ? (
                        <ImgFile2
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            setKey(preview.key)
                            base64(preview.uuid)
                          }}
                          src={pdf_icon}
                          alt="selected"
                        />
                      ) :
                        preview.key?.split('.').pop() === "png" ? (
                          <ImgFile2
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              setKey(preview.key)
                              base64(preview.uuid)
                            }}
                            src={png_icon}
                            alt="selected"
                          />
                        ) :
                          preview.key?.split('.').pop() === "jpg" ? (
                            <ImgFile2
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setKey(preview.key)
                                base64(preview.uuid)
                              }}
                              src={jpg_icon}
                              alt="selected"
                            />
                          ) : (
                            <ImgFile2
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                setKey(preview.key)
                                base64(preview.uuid)
                              }}
                              src={jpeg_icon}
                              alt="selected"
                            />
                          )}
                      <p
                        style={{ cursor: 'pointer', fontFamily: 'ubuntu', fontSize: '12pt' }}
                        onClick={() => {
                          setKey(preview.key)
                          base64(preview.uuid)
                        }}
                      >
                        <span>
                          {preview.key}
                          <IconButton>
                            <Icon>file_open</Icon>
                          </IconButton>
                        </span>
                      </p>
                      <ButtonDiv style={{ cursor: 'pointer' }} onClick={() => removePreview(preview)}>x</ButtonDiv>
                    </DivFile>
                    <br />
                  </ListItemButton>
                </>
              );
            })
              : files.map((file) => {
                return (
                  <>
                    <ListItemButton sx={{ pl: 4 }}>
                      <DivFile key={file.localUrl} style={{ flex: 1 }}>
                        {file.name?.split('.').pop() === "pdf" ? (
                          <ImgFile2
                            alt="selected"
                            src={pdf_icon}
                            onClick={() => {
                              setSrc(file.localUrl)
                              setKey(file.name)
                              setOpen(true)
                            }}
                          />
                        ) : (
                          <ImgFile2
                            alt="selected"
                            src={file.localUrl}
                            onClick={() => {
                              setSrc(file.localUrl)
                              setKey(file.name)
                              setOpen(true)
                            }}
                          />
                        )}
                        <p
                          style={{ cursor: 'pointer', fontFamily: 'ubuntu', fontSize: '12pt' }}
                          onClick={() => {
                            setSrc(file.localUrl)
                            setKey(file.name)
                            setOpen(true)
                          }}
                        >
                          <span>
                            {file.name}
                            <IconButton>
                              <Icon>file_open</Icon>
                            </IconButton>
                          </span>
                        </p>
                        <ButtonDiv style={{ cursor: 'pointer' }} onClick={() => remove(file)}>x</ButtonDiv>
                      </DivFile>
                      <br />
                    </ListItemButton>
                  </>
                );
              })}
          </List>

          <Modal
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            style={{ overflow: "scroll", display: 'flex', flexDirection: 'row', justifyContent: 'center', }}
          >
            {key?.split('.').pop() === "pdf" ? (
              <PDFView src={src} alt="selected" />
            ) : (
              <ImageView preview={NameDescription.split('Adicionar ')[1].toUpperCase()} src={src} setOpen={() => setOpen(false)} />
            )}
          </Modal>
        </Collapse>
      </List>
    </DropzoneFilesContainer>
  );
}
